<project-summary-calendar [loading]="loading" [events]="projectStatistics?.upcomingEvents" />
